/**
 * Song Manager
 *
 * Manages available songs and their metadata
 */

export interface SongInfo {
  id: string;
  title: string;
  artist: string;
  audioPath: string;
  chartPath: string;
  difficulty?: string;
}

export class SongManager {
  private songs: Map<string, SongInfo> = new Map();

  constructor() {
    this.loadSongList();
  }

  /**
   * Load the list of available songs
   */
  private loadSongList(): void {
    // Define available songs
    const songList: SongInfo[] = [
      {
        id: 'playful-massacre',
        title: 'Playful Massacre',
        artist: 'Azali',
        audioPath: '/assets/songs/playful-massacre/audio.mp3',
        chartPath: '/assets/songs/playful-massacre/chart.json',
        difficulty: 'Hard'
      },
      {
        id: 'battle-under-broken-sky',
        title: 'Battle Under a Broken Sky',
        artist: 'Azali',
        audioPath: '/assets/songs/battle-under-broken-sky/audio.mp3',
        chartPath: '/assets/songs/battle-under-broken-sky/chart.json',
        difficulty: 'Expert'
      },
      {
        id: 'chaos-construct',
        title: 'Chaos Construct',
        artist: 'Azali',
        audioPath: '/assets/songs/chaos-construct/audio.mp3',
        chartPath: '/assets/songs/chaos-construct/chart.json',
        difficulty: 'Expert'
      }
    ];

    for (const song of songList) {
      this.songs.set(song.id, song);
    }

    console.log(`SongManager loaded ${this.songs.size} songs`);
  }

  /**
   * Get all available songs
   */
  getAllSongs(): SongInfo[] {
    return Array.from(this.songs.values());
  }

  /**
   * Get a specific song by ID
   */
  getSong(id: string): SongInfo | undefined {
    return this.songs.get(id);
  }

  /**
   * Get the first available song (for quick play)
   */
  getFirstSong(): SongInfo | undefined {
    return this.getAllSongs()[0];
  }
}
